import { Injectable } from '@angular/core';
import { endpoint } from '@tekman/onmat/constants';
import { RubricsAnswersModel } from '@tekman/onmat/models';
import { ApiService } from '@tekman/onmat/service/generic';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RubricsService {
  constructor(private apiService: ApiService) {}

  getAnswersMultiResponse(activityId: string, groupId: string, studentId: string): Observable<RubricsAnswersModel> {
    const url = this.apiService.replaceUrl(
      this.apiService.replaceUrl(
        this.apiService.replaceUrl(endpoint.activity.student.multiAnswers, '{id}', activityId),
        '{groupId}',
        groupId
      ),
      '{studentId}',
      studentId
    );
    return this.apiService.get<RubricsAnswersModel>(url);
  }
}
